import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { TheCard } from "flowbite-vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CardComponent',
    props: {
        header: {},
        label1: {},
        label1Data: {},
        label2: {},
        label2Data: {},
        label3: {},
        label3Data: {},
        label4: {},
        label4Data: {},
        label5: {},
        label5Data: {},
        label6: {},
        label6Data: {},
        label7: {},
        label7Data: {}
    },
    emits: ["edit-details"],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var props = __props;
        return function (_ctx, _cache) {
            return (_openBlock(), _createBlock(_unref(TheCard), {
                href: "#",
                onClick: _cache[0] || (_cache[0] = function ($event) { return (_ctx.$emit('edit-details')); })
            }, {
                default: _withCtx(function () { return [
                    _createElementVNode("h1", null, _toDisplayString(_ctx.header), 1),
                    _createElementVNode("p", null, [
                        _createElementVNode("label", null, _toDisplayString(_ctx.label1), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.label1Data), 1)
                    ]),
                    _createElementVNode("p", null, [
                        _createElementVNode("label", null, _toDisplayString(_ctx.label2), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.label2Data), 1)
                    ]),
                    _createElementVNode("p", null, [
                        _createElementVNode("label", null, _toDisplayString(_ctx.label3), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.label3Data), 1)
                    ]),
                    _createElementVNode("p", null, [
                        _createElementVNode("label", null, _toDisplayString(_ctx.label4), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.label4Data), 1)
                    ]),
                    _createElementVNode("p", null, [
                        _createElementVNode("label", null, _toDisplayString(_ctx.label5), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.label5Data), 1)
                    ]),
                    _createElementVNode("p", null, [
                        _createElementVNode("label", null, _toDisplayString(_ctx.label6), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.label6Data), 1)
                    ]),
                    _createElementVNode("p", null, [
                        _createElementVNode("label", null, _toDisplayString(_ctx.label7), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.label7Data), 1)
                    ])
                ]; }),
                _: 1
            }));
        };
    }
});
